<template>
  <div>
    <div class="wf-flex wf-items-center wf-mt-4">
      <button
        @click.prevent="toggleTopSection"
        :class="hasTopSection ? ['wf-bg-indigo-600 '] : ['wf-bg-gray-200']"
        class="wf-h-6 wf-w-6 wf-rounded wf-border wf-text-xs wf-items-center wf-flex wf-justify-center"
      ><i v-show="hasTopSection" class="fas fa-check wf-text-white"></i></button>
      <span class="wf-ml-2 wf-text-xs wf-uppercase wf-font-bold wf-tracking-wide wf-text-gray-800">Top Section</span>
    </div>
  </div>
</template>

<script>
  import {SectionFactory} from '../../factories/SectionFactory'
  import ArrayManipulation from '../../mixins/ArrayManipulation'
  export default {
    mixins: [ArrayManipulation],
    computed: {
      hasTopSection() {
        return !! this.$store.getters['topSectionModule/elements']()
      },
    },
    methods: {
      toggleTopSection() {
        this.hasTopSection ? this.removeTopSection() : this.addTopSection()
      },
      removeTopSection() {
        this.addToObject('layoutModule', null, 'topSection')
      },
      addTopSection() {
        this.addToObject('layoutModule', (new SectionFactory).create()[0], 'topSection')
      }
    }
  }
</script>